module.exports = __webpack_public_path__ + "static/img/authkey.4a1d0cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/app/authkey.png
// module id = GpO0
// module chunks = 0